const TICS = Array.from({ length: 12 }, (_, i) => {
  const a = (i * 30 * Math.PI) / 180;
  return {
    x1: 32 + 25.4 * Math.cos(a), y1: 32 + 25.4 * Math.sin(a),
    x2: 32 + 28.6 * Math.cos(a), y2: 32 + 28.6 * Math.sin(a),
  };
});

export default function Logo({ size = 40, iconSize = 22, className = "", logoUrl = "", clair = false }) {
  if (logoUrl) {
    return (
      <div className={`rounded-lg bg-white border border-[#E6DFD1] flex items-center justify-center shrink-0 overflow-hidden ${className}`}
           style={{ width: size, height: size }} data-testid="logo-entreprise">
        <img src={logoUrl} alt="Logo de l'entreprise"
             style={{ maxWidth: "85%", maxHeight: "85%", objectFit: "contain" }} />
      </div>
    );
  }
  const trait = clair ? "#12100D" : "#D9A461";
  return (
    <div className={`rounded-lg border flex items-center justify-center shrink-0 ${clair ? "bg-white border-[#E6DFD1]" : "bg-[#12100D] border-[#D9A461]/30"} ${className}`}
         style={{ width: size, height: size }} data-testid="logo-mastoras">
      <svg width={iconSize} height={iconSize} viewBox="0 0 64 64" fill="none"
           stroke={trait} strokeLinecap="round" strokeLinejoin="round" aria-label="Logo Mastoras">
        <circle cx="32" cy="32" r="29.6" strokeWidth="2.2" />
        <circle cx="32" cy="32" r="23.6" strokeWidth="2.2" />
        {TICS.map((t, i) => (
          <line key={i} x1={t.x1} y1={t.y1} x2={t.x2} y2={t.y2} strokeWidth="1.8" />
        ))}
        <path d="M 21 44 L 21 22 L 32 35 L 43 22 L 43 44" strokeWidth="5" />
        <circle cx="32" cy="41" r="2.6" fill={trait} stroke="none" />
      </svg>
    </div>
  );
}
